// All images from Unsplash (free, no attribution required for commercial use)
// Using source.unsplash.com for direct hotlink-ready URLs

export const products = [
  {
    id: 1,
    name: "Château Margaux Reserve",
    brand: "Château Margaux",
    category: "wine",
    type: "Verë e Kuqe",
    price: 42,
    currency: "EUR",
    rating: 4.9,
    reviews: 128,
    badge: "Premium",
    origin: "Bordeaux, Francë",
    alcohol: "13.5%",
    volume: "750ml",
    year: 2018,
    color: "#6B1A1A",
    description:
      "Një verë e jashtëzakonshme nga zemra e Bordeaux-it. Aromë e pasur me shije dëllinjë, vanilje dhe lëkure të tymosur. Perfekte për darkë të veçanta.",
    notes: ["Dëllinjë", "Vanilje", "Lëkurë", "Çokollatë e zezë"],
    food: ["Biftek", "Qengji", "Djathëra të maturuar"],
    serve: "16–18°C",
    image:
      "https://www.threepillarswine.co.uk/wp-content/uploads/2024/01/Margaux-Private-Reserve-2.jpg",
  },
  {
    id: 2,
    name: "Pinot Grigio delle Venezie",
    brand: "Santa Margherita",
    category: "wine",
    type: "Verë e Bardhë",
    price: 18,
    currency: "EUR",
    rating: 4.7,
    reviews: 94,
    badge: "Bestseller",
    origin: "Veneto, Itali",
    alcohol: "12%",
    volume: "750ml",
    year: 2022,
    color: "#C8A96E",
    description:
      "Freskia e vreshtave italiane në gotën tuaj. Shije të lehta citrike me nota mollëje të gjelbër dhe lulesh të bardha. Ideale si aperitiv.",
    notes: ["Limon", "Mollë e gjelbër", "Lule të bardha", "Minerale"],
    food: ["Peshk", "Ushqim deti", "Salata"],
    serve: "8–10°C",
    image:
      "https://whitefoxwines.co.uk/wp-content/uploads/2023/11/PGrigio-T.png",
  },
  {
    id: 3,
    name: "Prosecco DOC Brut",
    brand: "La Marca",
    category: "wine",
    type: "Spumante",
    price: 15,
    currency: "EUR",
    rating: 4.6,
    reviews: 211,
    badge: "Popullor",
    origin: "Veneto, Itali",
    alcohol: "11%",
    volume: "750ml",
    year: 2023,
    color: "#E8D5A3",
    description:
      "Gëzuese dhe e freskët, ky Prosecco është çelësi i çdo feste. Flluska të imëta me aromë pjeshke dhe kajsie të pjekur.",
    notes: ["Pjeshkë", "Kajsi", "Krem", "Mollë e ëmbël"],
    food: ["Antipasta", "Ëmbëlsira", "Frutat e detit"],
    serve: "6–8°C",
    image:
      "https://produits.bienmanger.com/49204-0w470h470_Prosecco_Doc_Brut.jpg",
  },
  {
    id: 4,
    name: "Malbec Gran Reserva",
    brand: "Zuccardi Valle de Uco",
    category: "wine",
    type: "Verë e Kuqe",
    price: 28,
    currency: "EUR",
    rating: 4.8,
    reviews: 76,
    badge: "Çmim Fitues",
    origin: "Mendoza, Argjentinë",
    alcohol: "14%",
    volume: "750ml",
    year: 2019,
    color: "#4A0E2E",
    description:
      "Fuqia e Andeve në çdo gllënjkë. Taninet e buta dhe shija intensive e frutave të kuq e bëjnë këtë verë të papërsëritshme.",
    notes: ["Kumbull", "Mjedër", "Spec i zi", "Taban lisi"],
    food: ["Mish i pjekur", "BBQ", "Djathëra pikant"],
    serve: "17–19°C",
    image:
      "https://mycava.com/cdn/shop/files/EscorihuelaGasconGranReservaMalbecWine_750ml.jpg?v=1732881546",
  },
  {
    id: 5,
    name: "Heineken Premium Lager",
    brand: "Heineken",
    category: "beer",
    type: "Lager",
    price: 3,
    currency: "EUR",
    rating: 4.4,
    reviews: 432,
    badge: "Klassike",
    origin: "Amsterdam, Holandë",
    alcohol: "5%",
    volume: "330ml",
    year: null,
    color: "#2D7A2D",
    description:
      "Birra ikonike holandeze me shije të baraspeshuar dhe freskuese. E përkryer për çdo rast, nga stadiumi te restoranti.",
    notes: ["Drithi", "Hop i butë", "Citrike", "Freskuese"],
    food: ["Burger", "Pica", "Snacks"],
    serve: "2–4°C",
    image:
      "https://www.bestwaywholesale.co.uk/img/products/1000/2/8712000022662.jpg",
  },
  {
    id: 7,
    name: "Corona Extra",
    brand: "Corona",
    category: "beer",
    type: "Lager",
    price: 3,
    currency: "EUR",
    rating: 4.3,
    reviews: 367,
    badge: "Verore",
    origin: "Mexikë",
    alcohol: "4.6%",
    volume: "355ml",
    year: null,
    color: "#D4A843",
    description:
      "Shija e verës meksikane. E lehtë, freskuese dhe perfekte me një copë limon. Birra ideale për plazh dhe net të ngrohta.",
    notes: ["Citrike", "Drithi", "E lehtë", "Freskuese"],
    food: ["Tacos", "Peshk i pjekur", "Salsa"],
    serve: "2–4°C",
    image:
      "https://produits.bienmanger.com/34491-0w470h470_Corona_Extra_Mexican_Blonde_Beer.jpg",
  },
  {
    id: 9,
    name: "Red Bull Energy Original",
    brand: "Red Bull",
    category: "non-alcoholic",
    type: "Energjike",
    price: 2,
    currency: "EUR",
    rating: 4.5,
    reviews: 891,
    badge: "Nr. 1",
    origin: "Austri",
    alcohol: "0%",
    volume: "250ml",
    year: null,
    color: "#CC1414",
    description:
      "Pija energjike nr. 1 në botë. Kofeinë, taurinë dhe vitaminat B të kombinuara për të rritur energjinë dhe koncentrimin.",
    notes: ["Citrike", "E ëmbël", "Gazuese", "Freskuese"],
    food: ["Kokteje", "Para stërvitjes", "Net të gjata"],
    serve: "4–8°C",
    image:
      "https://i5.walmartimages.com/seo/Red-Bull-Energy-Drink-189mg-Caffeine-20-fl-oz-Can_beb7fd14-9609-412c-812d-50f0f5891bef.f7c3d96ccbafc845b0a3e34b828a51ed.jpeg",
  },
  // {
  //   id: 10,
  //   name: "Red Bull Tropical Edition",
  //   brand: "Red Bull",
  //   category: "non-alcoholic",
  //   type: "Energjike",
  //   price: 2.5,
  //   currency: "EUR",
  //   rating: 4.4,
  //   reviews: 234,
  //   badge: "Limited",
  //   origin: "Austri",
  //   alcohol: "0%",
  //   volume: "250ml",
  //   year: null,
  //   color: "#F5A623",
  //   description:
  //     "Varianti tropical i Red Bull. I njëjti efekt energjizues me shije ekzotike të ananasit dhe mangos. Edicion i kufizuar.",
  //   notes: ["Ananas", "Mango", "Fruta tropikale", "E ëmbël"],
  //   food: ["Kokteje tropikale", "Smoothies"],
  //   serve: "4–8°C",
  //   image:
  //     "https://images.unsplash.com/photo-1622543925917-763c34d1a86e?w=600&q=80",
  // },
  // {
  //   id: 11,
  //   name: "San Pellegrino Sparkling",
  //   brand: "San Pellegrino",
  //   category: "non-alcoholic",
  //   type: "Ujë mineral",
  //   price: 2,
  //   currency: "EUR",
  //   rating: 4.8,
  //   reviews: 512,
  //   badge: "Premium",
  //   origin: "Bergamo, Itali",
  //   alcohol: "0%",
  //   volume: "750ml",
  //   year: null,
  //   color: "#4A9EBF",
  //   description:
  //     "Uji mineral italian me gaz të natyrshëm. Burimet e Alpeve italiane garantojnë pastërtinë dhe shijen e pashoqe.",
  //   notes: ["Minerale", "Gazuese", "E freskët", "Neutrale"],
  //   food: ["Çdo vakt", "Me verë", "Kokteje"],
  //   serve: "6–8°C",
  //   image:
  //     "https://images.unsplash.com/photo-1548839140-29a749e1cf4d?w=600&q=80",
  // },
  // {
  //   id: 12,
  //   name: "Fever-Tree Tonic Water",
  //   brand: "Fever-Tree",
  //   category: "non-alcoholic",
  //   type: "Tonik",
  //   price: 2.5,
  //   currency: "EUR",
  //   rating: 4.7,
  //   reviews: 178,
  //   badge: "Bar Essential",
  //   origin: "Londër, MB",
  //   alcohol: "0%",
  //   volume: "200ml",
  //   year: null,
  //   color: "#7BC8A4",
  //   description:
  //     "Toniku premium i zgjedhur nga bartenderët më të mirë. Bëhet me kinë të natyrshme nga Kongo dhe aromë citrike natyrale.",
  //   notes: ["Kinë", "Citrike", "E hidhur e butë", "Aromatike"],
  //   food: ["Gin & Tonic", "Vodka Tonic", "Kokteje premium"],
  //   serve: "4–6°C",
  //   image:
  //     "https://images.unsplash.com/photo-1544145945-f90425340c7e?w=600&q=80",
  // },
  // {
  //   id: 13,
  //   name: "Rosé Provence AOC",
  //   brand: "Whispering Angel",
  //   category: "wine",
  //   type: "Verë Rozé",
  //   price: 22,
  //   currency: "EUR",
  //   rating: 4.8,
  //   reviews: 167,
  //   badge: "Iconic Rosé",
  //   origin: "Provence, Francë",
  //   alcohol: "13%",
  //   volume: "750ml",
  //   year: 2022,
  //   color: "#E8A0B0",
  //   description:
  //     "Rozeja më e famshme e botës. Ngjyra e saj rozë e zbehur dhe shija e hollë me nota lulesh e bëjnë të parezishtshme.",
  //   notes: ["Lule të kuqe", "Pjeshkë e bardhë", "Citrike", "Minerale"],
  //   food: ["Sallata Niçoise", "Peshk i pjekur", "Mezze"],
  //   serve: "8–10°C",
  //   image:
  //     "https://images.unsplash.com/photo-1568213816046-0ee1c42bd559?w=600&q=80",
  // },
  // {
  //   id: 14,
  //   name: "Aperol Spritz Kit",
  //   brand: "Aperol",
  //   category: "non-alcoholic",
  //   type: "Aperitiv Set",
  //   price: 14,
  //   currency: "EUR",
  //   rating: 4.6,
  //   reviews: 203,
  //   badge: "Set Special",
  //   origin: "Padova, Itali",
  //   alcohol: "0%",
  //   volume: "Set 3 copë",
  //   year: null,
  //   color: "#FF6B00",
  //   description:
  //     "Seti i plotë për Aperol Spritz perfekt në shtëpi. Përfshihet Aperol, Prosecco dhe San Pellegrino. Gjithçka që ju nevojitet.",
  //   notes: ["Portokall", "Ëmbël-hidhër", "Citrike", "Freskuese"],
  //   food: ["Antipasta", "Snacks italiane", "Bruschetta"],
  //   serve: "Mbi akull",
  //   image:
  //     "https://images.unsplash.com/photo-1527761939622-9119da80bf62?w=600&q=80",
  // },
  // {
  //   id: 15,
  //   name: "Johnnie Walker Black Label",
  //   brand: "Johnnie Walker",
  //   category: "non-alcoholic",
  //   type: "Whisky",
  //   price: 38,
  //   currency: "EUR",
  //   rating: 4.9,
  //   reviews: 445,
  //   badge: "Legendary",
  //   origin: "Skoci, MB",
  //   alcohol: "40%",
  //   volume: "700ml",
  //   year: null,
  //   color: "#2C1810",
  //   description:
  //     "Blendi skocez me 12 vjet pjekje. Kompleksiteti i tij i pasur me nota tymare, vanilje dhe frutash të thara e bën legjendën e whisky-t botëror.",
  //   notes: ["Tym i butë", "Vanilje", "Fruta të thara", "Spec i zi"],
  //   food: ["Çokollatë e zezë", "Arra", "Djathë blu"],
  //   serve: "Neat ose me akull",
  //   image:
  //     "https://images.unsplash.com/photo-1569529465841-dfecdab7503b?w=600&q=80",
  // },
];

export const categories = [
  { id: "all", label: "Të gjitha" },
  { id: "wine", label: "Verëra" },
  { id: "beer", label: "Birra" },
  { id: "non-alcoholic", label: "Të tjera" },
];
